import { type ReactNode } from 'react';
import { BrandLogo } from './BrandLogo';

export interface TopBarProps {
  brandName?: string;
  activeExam?: string;
  entitlementLabel?: string;
  contextNote?: string;
  language?: string;
  accountSlot?: ReactNode;
}

export function TopBar({
  brandName = 'ExamFlow',
  activeExam,
  entitlementLabel,
  contextNote,
  language,
  accountSlot,
}: TopBarProps) {
  return (
    <header className="flex h-[68px] w-full items-center gap-4 border-b border-sage-300 bg-surface-secondary px-[50px]">
      <div className="mr-4 flex items-center">
        <BrandLogo variant="full" size={32} alt={brandName} />
      </div>

      {activeExam && (
        <span className="rounded-md border border-sage-300 bg-sage-50 px-3 py-1 font-mono text-xs text-ink-secondary">
          {activeExam}
        </span>
      )}
      {entitlementLabel && (
        <span className="rounded-md bg-teal-surface px-3 py-1 font-sans text-xs font-semibold text-teal">
          {entitlementLabel}
        </span>
      )}

      {contextNote && (
        <span className="ml-2 font-mono text-xs text-ink-muted">{contextNote}</span>
      )}

      <div className="ml-auto flex items-center gap-4">
        {language && <span className="font-sans text-sm text-ink-muted">{language}</span>}
        {accountSlot}
      </div>
    </header>
  );
}
